var React = require('react');

function IcCartClose (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.5","y1":"-0.5","x2":"34.8553","y2":"-0.5","transform":"matrix(0.707107 0.707106 -0.707107 0.707106 1 1.00005)","stroke":"black","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"0.5","y1":"-0.5","x2":"34.8553","y2":"-0.5","transform":"matrix(0.707107 -0.707106 0.707107 0.707106 1 26)","stroke":"black","strokeLinecap":"round","key":1})]);
}

IcCartClose.defaultProps = {"width":"27","height":"26","viewBox":"0 0 27 26","fill":"none"};

module.exports = IcCartClose;

IcCartClose.default = IcCartClose;
